export const categories = [
  "Wedding Planning Services",
  "Pre-Schools & Day Care",
  "Spa & Wellness Centers",
  "AC Repair & Services",
  "Bike Repair & Maintenance",
  "Saree Stores & Ethnic Wear",
  "Astrology & Horoscope Services",
  "Restaurants & Cafes",
  "Home Cleaning Services",
  "Packers & Movers",
  "Hospitals & Clinics"
];

export const popularSearches = [
  "Verified AC repair services near you",
  "Best wedding planners in India",
  "Affordable bike repair services",
  "Trusted pre-schools for early education",
  "Spa and wellness centers nearby",
  "Top saree stores for weddings",
  "Astrology consultation services",
  "Reliable packers and movers",
  "Home cleaning services near you",
  "Hospitals and clinics for quality care",
  "Restaurants and cafes nearby",
  "Day care centers for kids"
];

export const cities = [
  "Vadodara",
  "Surat",
  "Ahmedabad",
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Pune",
  "Jaipur"
];